module.exports = __webpack_public_path__ + "img/img_06.51b0df56.webp";